import { trackSigninClickFromExistingUserMessage } from 'components/survey_signup_modal/tracking_helpers';

const uniqueEmailMessage = loginBaseUrl => (
  <span>
    Looks like you already have an account.{' '}
    <a
      className="reference-link"
      href={loginBaseUrl}
      onClick={trackSigninClickFromExistingUserMessage}
    >
      Sign in
    </a>
  </span>
);

export default {
  firstNameMessage: 'Hi, we’re Gusto. What’s your first name?',
  lastNameMessage: 'Hi, we’re Gusto. What’s your last name?',
  emailMessage: 'You’ll sign into Gusto with this email address.',
  firmMessage: 'What is the name of the accounting firm you work for?',
  websiteMessage: 'What is your company URL?',
  numberCompaniesMessage: 'How many clients does your firm work with?',
  numberPayrollCompaniesMessage: 'How many clients does your firm offer payroll services to?',
  phoneMessage: 'What’s your number? We won’t share it with anyone.',
  phoneLengthMessage: 'Must be 10 digits.',
  termsAcceptanceMessage: 'You must accept Gusto’s Terms and Privacy Policy',
  uniqueEmailMessage: loginBaseUrl => uniqueEmailMessage(loginBaseUrl),
};
